import './thegrandbevy/style';
import FormStructure from './thegrandbevy/form_structure';

export default FormStructure;